import React, { useCallback, useEffect, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Stack,
  TextField,
  Box,
  Drawer,
  Chip,
  Button,
  Avatar,
  Tabs,
  Tab,
  Autocomplete,
  Dialog,
  Tooltip,
} from "@mui/material";
import { IoClose, IoFilterSharp, IoFlagOutline } from "react-icons/io5";
import { FaListUl } from "react-icons/fa6";
import { MdOutlineSpaceDashboard } from "react-icons/md";
import { GoPlus } from "react-icons/go";
import { ImAttachment } from "react-icons/im";
import { LuMessageSquareText } from "react-icons/lu";
import filterIcon1 from "../../assets/images/filter1.svg";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import MasterCommonTable from "../../sharedComponents/MaterCommonTable/MasterCommonTable";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { jwtDecode } from "jwt-decode";
import { useAuth } from "../../context/AuthProvider";
import { debounce } from "../../utils/debounce";
import { Divider } from "antd";
import { ToastError } from "../../utils/Toaster/Toaster";
import AddTaskClient from "../../components/TaskManagement/AddTaskClient";
import { getProject } from "../../services/project.service";
import {
  getClientTaskList,
  deleteTask,
} from "../../services/taskManagement.service";
import { useNavigate } from "react-router-dom";
import bug from "../../assets/images/bug.png";
import Task_Icon from "../../assets/images/Task_Icon.svg";
import Meeting_Icon from "../../assets/images/Meeting.png";
import { STATUS, PRIORITY, ISSUETYPE } from "../../common/constant/constant";

dayjs.extend(require("dayjs/plugin/duration"));

// Helper functions using your numeric constants
// const getClientStatusLabel = (status) => {
//   console.log(status, "STATUS");
//   const statusMap = {
//     [STATUS.TODO]: "ToDo",
//     [STATUS.INPROGRESS]: "InProgress",
//     [STATUS.QA]: "QA",
//     [STATUS.PRODUCTION]: "Production",
//     [STATUS.STAGING]: "Staging",
//     // [STATUS.PENDING]: "Pending",
//     [STATUS.PENDING]: "To Do",
//     [STATUS.UAT]: "UAT",
//   };
//   return statusMap[status] || "To Do";
// };
const getClientStatusLabel = (status) => {
  const inProgressStatuses = new Set([
    STATUS.TODO,
    STATUS.INPROGRESS,
    STATUS.QA,
  ]);

  if (inProgressStatuses.has(status)) {
    return "InProgress";
  }

  const statusMap = {
    [STATUS.PRODUCTION]: "Production",
    [STATUS.STAGING]: "Staging",
    [STATUS.PENDING]: "To Do",
    [STATUS.UAT]: "UAT",
  };

  return statusMap[status] || "To Do";
};

const getPriorityLabel = (priorityValue) => {
  const priorityMap = {
    [PRIORITY.LOW]: "Low",
    [PRIORITY.MEDIUM]: "Medium",
    [PRIORITY.HIGH]: "High",
  };
  return priorityMap[priorityValue] || "Medium";
};

const getIssueTypeLabel = (issueTypeValue) => {
  const issueTypeMap = {
    [ISSUETYPE.BUG]: "Bugs",
    [ISSUETYPE.TASK]: "Task",
    [ISSUETYPE.TESTING]: "Testing",
    [ISSUETYPE.DESIGNING]: "Designing",
    [ISSUETYPE.OTHERS]: "Others",
    [ISSUETYPE.MEETING]: "Meeting",
  };
  return issueTypeMap[issueTypeValue] || "Task";
};

// const getPriorityColor = (priorityValue) => {
//   const priorityMap = {
//     [PRIORITY.HIGH]: "#D50707",
//     [PRIORITY.MEDIUM]: "#D7BB21",
//     [PRIORITY.LOW]: "#21A600",
//   };
//   return priorityMap[priorityValue] || "#21A600";
// };

const TaskList = ({
  tasks,
  tableTotalCount,
  setSelectedTask,
  setOpenDrawer,
  queryParam,
  handleView,
  handleEdit,
  handleDelete,
}) => {
  const columns = [
    { id: "deadlineDate", label: "Deadline" },
    { id: "ProjectName", label: "Project Name" },
    { id: "taskType", label: "Task Type" },
    { id: "title", label: "Title" },
    { id: "priority", label: "Priority" },
    { id: "clientStatus", label: "Status" },
  ];

  const tableConfig = {
    isMore: true,
    isAction: true,
    isEdit: true,
    isView: true,
    isClient: true,
    isServerSide: true,
    isSearch: false,
    isAddNew: false,
  };

  let data = [];
  for (const key in tasks) {
    data.push(...tasks[key]);
  }

  return (
    <MasterCommonTable
      tableConfig={tableConfig}
      data={data}
      columns={columns}
      tableTotalCount={tableTotalCount}
      handleView={handleView}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
    />
  );
};

const TaskBoard = ({
  tasks,
  handleView,
  handleAddTaskClick,
  renderTaskCard,
}) => {
  return (
    <Grid container spacing={3} style={{ padding: "0px" }}>
      {Object.keys(tasks).map((columnId) => (
        <Grid item xs={12} sm={6} md={3} key={columnId}>
          <Stack
            sx={{
              padding: "10px",
              backgroundColor: "#FBFBFB",
              borderRadius: "10px 10px 0 0",
              border: "1px solid #E5E9F1",
            }}
          >
            <Stack
              sx={{
                border: "1px solid #E5E9F1",
                borderRadius: "6px",
                padding: "6px 8px",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Stack
                sx={{
                  flexDirection: "row",
                  gap: "10px",
                  alignItems: "center",
                }}
              >
                <Typography variant="h6" sx={{ fontSize: 16 }}>
                  {columnId}
                </Typography>
                <Typography
                  sx={{
                    color: "#687280",
                  }}
                >
                  {tasks[columnId].length}
                </Typography>
              </Stack>
              <GoPlus
                size={20}
                onClick={handleAddTaskClick}
                style={{ cursor: "pointer" }}
              />
            </Stack>
          </Stack>
          <Stack
            spacing={1}
            sx={{
              padding: "10px",
              backgroundColor: "#FBFBFB",
              borderRadius: "0px 0px 6px 6px",
              border: "1px solid #E5E9F1",
              height: "600px",
              overflow: "auto",
              marginBottom: "60px",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            {tasks[columnId].length > 0 ? (
              tasks[columnId].map((task, index) => renderTaskCard(task, index))
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100px",
                  color: "#687280",
                  fontSize: "14px",
                }}
              >
                No tasks
              </Box>
            )}
          </Stack>
        </Grid>
      ))}
    </Grid>
  );
};

const NewClientTaskManagement = () => {
  const { accessToken } = useAuth();
  const [viewMode, setViewMode] = useState("list");
  const [tasks, setTasks] = useState({
    "To Do": [],
    // Pending: [],
    // InProgress: [],
    UAT: [],
    Production: [],
  });
  const [tableTotalCount, setTableTotalCount] = useState(0);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);
  const [projectData, setProjectData] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [openFilterDrawer, setOpenFilterDrawer] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({
    Priority: [],
    Status: [],
    "Issue Type": [],
  });
  const [tempFilters, setTempFilters] = useState({
    Priority: [],
    Status: [],
    "Issue Type": [],
  });

  const statusOptions = ["To Do", "InProgress", "UAT", "Production"];
  const priorityOptions = ["High", "Medium", "Low"];
  const issueTypeOptions = ["Bugs", "Task", "Testing", "Designing", "Others"];

  const currentDate = dayjs();

  const getUserIdFromToken = () => {
    if (!accessToken) return null;
    try {
      const decoded = jwtDecode(accessToken);
      return decoded.id;
    } catch (error) {
      console.error("Invalid token", error);
      return null;
    }
  };

  const clientId = getUserIdFromToken();

  const [queryParam, setQueryParam] = useState({
    project: null,
    priority: "",
    search: "",
    type: "",
    status: "",
    month: currentDate.month() + 1,
    year: currentDate.year(),
  });

  const [tempDate, setTempDate] = useState({
    month: queryParam.month,
    year: queryParam.year,
  });

  const [isDateFiltered, setIsDateFiltered] = useState(false);

  const GetProjectData = async () => {
    try {
      const res = await getProject({
        clientId: clientId,
        isEnabled: true,
      });
      if (res.data.data && Array.isArray(res.data.data)) {
        const configData = res?.data?.data?.map((e) => ({
          ...e,
          label: e.name,
        }));
        setProjectData(configData);
      } else {
        console.error("Response data is not in expected format:", res.data);
      }
    } catch (error) {
      console.error("Error fetching project data:", error);
    }
  };

  const GetClientTaskData = async () => {
    try {
      const queryParams = {
        client: clientId,
        project: selectedProject ? selectedProject : "",
        priority: queryParam.priority || "All",
        search: queryParam.search || "",
        type: queryParam.type || "",
        status: queryParam.status || "All",
        month: queryParam.month.toString(),
        year: queryParam.year.toString(),
      };
      const res = await getClientTaskList(queryParams);
      const modifiedData =
        res?.data?.data?.map((e) => ({
          ...e,
          deadlineDate: dayjs(e?.deadLineDate).format("DD/MM/YYYY"),
          clientStatus: getClientStatusLabel(e?.status),
          priority: getPriorityLabel(e?.priority),
          taskType: getIssueTypeLabel(e?.taskType || e?.issueType),
        })) || [];

      const updatedTasks = {
        "To Do": [],
        InProgress: [],
        // Pending: [],
        UAT: [],
        Production: [],
      };

      modifiedData.forEach((task) => {
        const clientStatus = getClientStatusLabel(task.status);
        if (updatedTasks[clientStatus]) {
          updatedTasks[clientStatus].push(task);
        }
      });

      setTasks(updatedTasks);
      setTableTotalCount(res?.data?.totalCount || 0);
    } catch (error) {
      console.error("Error fetching tasks:", error);
    }
  };

  useEffect(() => {
    GetClientTaskData();
  }, [queryParam, selectedProject]);

  useEffect(() => {
    GetProjectData();
  }, []);

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((prevParams) => ({
        ...prevParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };

  const handleAddTaskClick = () => {
    setSelectedTask({});
    setOpenDrawer(true);
  };

  // const handleTaskClick = (task) => {
  //   setSelectedTask(task);
  //   setOpenDrawer(true);
  // };

  const handleViewModeChange = (newValue) => {
    setViewMode(newValue === "one" ? "board" : "list");
  };

  const handleProjectChange = (newValue) => {
    setSelectedProject(newValue?._id || null);
  };

  const truncateText = (text, maxLength = 30) => {
    return text
      ? text.length > maxLength
        ? `${text.substring(0, maxLength)}...`
        : text
      : "-";
  };

  const handleFilterClick = () => {
    setTempFilters(selectedFilters);
    setOpenFilterDrawer(true);
  };

  const handleCloseFilterDrawer = () => {
    setOpenFilterDrawer(false);
  };

  // const handleDateChange = (e) => {
  //   const selectedDate = dayjs(e?.$d);
  //   setQueryParam({
  //     ...queryParam,
  //     month: selectedDate.month() + 1,
  //     year: selectedDate.year() || queryParam.year,
  //   });
  // };

  const handleRemoveFilter = (filterType, valueToRemove) => {
    setTempFilters((prev) => ({
      ...prev,
      [filterType]: prev[filterType].filter((val) => val !== valueToRemove),
    }));
  };

  const handleApplyFilters = () => {
    setSelectedFilters(tempFilters);
    setIsDateFiltered(
      tempDate.month !== currentDate.month() + 1 ||
        tempDate.year !== currentDate.year()
    );

    setQueryParam({
      ...queryParam,
      month: tempDate.month,
      year: tempDate.year,
      status: tempFilters.Status.length > 0 ? tempFilters.Status.join(",") : "",
      priority:
        tempFilters.Priority.length > 0 ? tempFilters.Priority.join(",") : "",
      type:
        tempFilters["Issue Type"].length > 0
          ? tempFilters["Issue Type"].join(",")
          : "",
    });
    setOpenFilterDrawer(false);
  };

  const handleClearAll = () => {
    setTempFilters({
      Priority: [],
      Status: [],
      "Issue Type": [],
    });
    setTempDate({
      month: currentDate.month() + 1,
      year: currentDate.year(),
    });
    setQueryParam({
      ...queryParam,
      month: currentDate.month() + 1,
      year: currentDate.year(),
      priority: "",
      type: "",
      status: "",
    });
    setSelectedFilters({
      Priority: [],
      Status: [],
      "Issue Type": [],
    });
    setIsDateFiltered(false);
  };

  const navigate = useNavigate();

  const handleView = (task) => {
    task.isView = true;
    setSelectedTask(task);
    navigate(`/home/taskDetails?taskId=${task._id}`, {
      state: {
        selectedMonth: queryParam.month,
        selectedYear: queryParam.year,
        fromClient: true,
      },
    });
  };

  const handleEdit = (task) => {
    task.isView = false;
    setSelectedTask(task);
    setOpenDrawer(true);
  };

  const handleDelete = async (task) => {
    try {
      const res = await deleteTask(task._id);
      ToastError(res.message);
      GetClientTaskData();
    } catch (error) {
      console.error("Error deleting task:", error);
    }
  };

  const filterOptions = [
    { title: "Priority", options: priorityOptions },
    { title: "Status", options: statusOptions },
    { title: "Issue Type", options: issueTypeOptions },
  ];

  const renderTaskCard = (task, index) => (
    <div key={task._id} onClick={() => handleView(task)}>
      <Card
        elevation={0}
        sx={{
          boxShadow: "none",
          border: task?.clientVerifyStatus == 1 ? "2px solid orange" : "2px solid #E5E9F1",
          // border: "2px solid #E5E9F1",
          paddingBottom: "0px",
          height: "100%",
          cursor: "pointer",
          borderRadius: "10px",
        }}
      >
        <CardContent sx={{ paddingBottom: "15px !important" }}>
          <Stack
            sx={{
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              mb: "6px",
            }}
          >
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                gap: "3px",
              }}
            >
              <IoFlagOutline
                size={16}
                color={
                  task.priority === PRIORITY.HIGH
                    ? "#D50707" // Red
                    : task.priority === PRIORITY.MEDIUM
                    ? "#D7BB21" // Yellow
                    : "#21A600" // Green
                }
              />
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: 500,
                  fontFamily: "Inter, sans-serif",
                  marginLeft: "4px",
                  color: "#000000",
                }}
              >
                {task?.taskNo}
              </Typography>
            </Stack>

            <Stack direction={"row"} sx={{alignItems:"center"}} spacing={0.4}>
              {task.issueType === ISSUETYPE.BUG ? (
                <>
                  <img
                    src={bug}
                    alt="Bug icon"
                    style={{ width: "20px", height: "20px" }}
                  />
                </>
              ) : task.issueType === ISSUETYPE.MEETING ? (
                <>
                  <img
                    src={Meeting_Icon}
                    alt="Meeting_Icon"
                    style={{ width: "20px", height: "20px" }}
                  />
                </>
              ) : (
                <>
                  <img
                    src={Task_Icon}
                    alt="Task_Icon"
                    style={{ width: "20px", height: "20px" }}
                  />
                </>
              )}
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: 500,
                  fontFamily: "Inter, sans-serif",
                }}
              >
                {task.issueType === ISSUETYPE.BUG ? "Bug" : task.issueType === ISSUETYPE.MEETING ? "Meeting" : "Task"}
              </Typography>
            </Stack>
            {task?.status === STATUS.PRODUCTION && (
              <Stack
                sx={{
                  flexDirection: "row",
                  alignItems: "center",
                  gap: "3px",
                  zIndex: 99999,
                }}
                onClick={() => {
                  console.log("CLICKED");
                }}
              >
                <Button
                  sx={{
                    fontSize: "12px",
                    color: "#000000",
                    fontWeight: "500",
                  }}
                >
                  Need Verified
                </Button>
              </Stack>
            )}
          </Stack>
          <Stack>
            <Divider
              style={{
                margin: "0px",
                border: "0.6px solid #E5E9F1",
                // mt: "5px",
                // mb: "5px",
              }}
            />
          </Stack>
          <Typography
            sx={{
              fontSize: "15px",
              marginTop: "6px",
              fontWeight: 500,
              // fontWeight: "bold",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "200px",
              fontFamily: "Inter, sans-serif",
            }}
          >
            {task?.title}
          </Typography>
          <Typography
            sx={{
              fontSize: "12px",
              color: "#687280",
              fontWeight: 400,
              fontFamily: "Inter, sans-serif",
              mt: "3px",
            }}
          >
            {truncateText(task?.description?.replace(/<\/?[^>]+(>|$)/g, ""))}
          </Typography>
          <Stack
            sx={{
              flexDirection: "row",
              gap: "6px",
              justifyContent: "space-between",
              marginTop: "10px",
            }}
          >
            <Stack
              sx={{
                flexDirection: "row",
                gap: "6px",
                alignItems: "center",
              }}
            >
              {/* {task.issueType === ISSUETYPE.BUG ? (
                <img src={bug} style={{ width: "20px", height: "20px" }} />
              ) : (
                <img
                  src={Task_Icon}
                  style={{ width: "20px", height: "20px" }}
                />
              )} */}
              <Stack
                sx={{
                  flexDirection: "row",
                  padding: "2px 4px",
                  border: "1px solid #E5E9F1",
                  borderRadius: "3px",
                  alignItems: "center",
                  gap: "3px",
                  backgroundColor: "#FBFBFB",
                }}
              >
                <ImAttachment />
                <Typography fontSize={"12px"}>
                  {task?.file?.length || 0}
                </Typography>
              </Stack>
              <Stack
                sx={{
                  flexDirection: "row",
                  padding: "2px 4px",
                  border: "1px solid #E5E9F1",
                  borderRadius: "3px",
                  alignItems: "center",
                  gap: "3px",
                  backgroundColor: "#FBFBFB",
                }}
              >
                <LuMessageSquareText />
                <Typography fontSize={"12px"}>
                  {task?.comments?.length || 0}
                </Typography>
              </Stack>
              {/* <Stack
                sx={{
                  flexDirection: "row",
                  padding: "2px 4px",
                  border: "1px solid #E5E9F1",
                  borderRadius: "3px",
                  alignItems: "center",
                  gap: "3px",
                  backgroundColor: "#FBFBFB",
                }}
              >
                <VscRepoForked style={{ transform: "rotate(180deg)" }} />
                <Typography fontSize={"12px"}>
                  {task?.subTasks?.length || 0}
                </Typography>
              </Stack> */}
            </Stack>
            <Stack
              sx={{
                flexDirection: "row",
                alignItems: "center",
                position: "relative",
              }}
            >
              <Tooltip 
                title={
                  task?.assignedToDetails
                    ? `${task.assignedToDetails.firstName} ${task.assignedToDetails.lastName}`
                    : "No assignee"
                }
                arrow
                placement="bottom"
              >
                <Avatar
                  sx={{
                    width: "25px",
                    height: "25px",
                    fontSize: "14px",
                    backgroundColor: "#C7EEEF",
                    color: "#055253",
                    fontWeight: 500,
                    cursor: "pointer",
                  }}
                  alt={
                    task?.assignedToDetails
                      ? `${task.assignedToDetails.firstName} ${task.assignedToDetails.lastName}`
                      : "Profile"
                  }
                  src={
                    task?.assignedToDetails
                      ? task.assignedToDetails?.file?.location
                      : undefined
                  }
                >
                  {/* This content only shows when image fails to load or doesn't exist */}
                  {!task?.assignedToDetails?.file?.locations && (
                    task?.assignedToDetails
                      ? `${task.assignedToDetails.firstName?.charAt(0) || ""}${
                          task.assignedToDetails.lastName?.charAt(0) || ""
                        }`.toUpperCase()
                      : "?"
                  )}
                </Avatar>
              </Tooltip>
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </div>
  );

  return (
    <Grid sx={{ height: "100vh", overflowY: "auto" }}>
      <Stack marginTop={3}>
        <Typography sx={{ fontSize: "16px" }}>All Tasks</Typography>
        <Typography sx={{ fontSize: "14px", color: "#687280" }}>
          View, assign and manage all tasks—track deadlines, priorities, and
          status updates.
        </Typography>

        <Grid
          container
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          mt={2}
        >
          <Grid item md={2.5}>
            <Box
              sx={{
                width: "75%",
                border: "1px solid #D5DBDE",
                padding: "5px",
                borderRadius: "6px",
              }}
            >
              <Tabs
                value={viewMode === "board" ? "one" : "two"}
                onChange={(e, newValue) => handleViewModeChange(newValue)}
                textColor="black"
                indicatorColor="transparent"
                aria-label="secondary tabs example"
                sx={{
                  minHeight: "24px !important",
                  padding: "0px !important",
                }}
              >
                <Tab
                  value="one"
                  label="Board"
                  icon={<MdOutlineSpaceDashboard />}
                  iconPosition="start"
                  sx={{
                    color: "black",
                    backgroundColor:
                      viewMode === "board" ? "#E5E9F1" : "transparent",
                    borderRadius: "6px",
                    padding: "10px !important",
                    height: "10px !important",
                    minHeight: "30px !important",
                    fontSize: "12px",
                  }}
                />
                <Tab
                  value="two"
                  label="List"
                  icon={<FaListUl />}
                  iconPosition="start"
                  sx={{
                    color: "black",
                    backgroundColor:
                      viewMode === "list" ? "#E5E9F1" : "transparent",
                    borderRadius: "6px",
                    padding: "0px !important",
                    height: "10px !important",
                    minHeight: "30px !important",
                    fontSize: "12px",
                  }}
                />
              </Tabs>
            </Box>
          </Grid>
          <Grid item md={8}>
            <Grid
              container
              spacing={2}
              justifyContent={"center"}
              alignItems={"center"}
            >
              <Grid item md={4}>
                <Stack>
                  <Box
                    className="SearchInputBoxContainer"
                    sx={{ margin: 0, paddingLeft: 0 }}
                  >
                    <input
                      className="SearchInputBox"
                      placeholder="Search Here"
                      onChange={(e) => handleSearch(e.target.value)}
                      style={{ backgroundColor: "#f7f7f7" }}
                    />
                    <SearchOutlinedIcon className="Search_Icon" />
                  </Box>
                </Stack>
              </Grid>
              <Grid item md={4}>
                <Autocomplete
                  options={projectData}
                  getOptionLabel={(option) => option?.label || ""}
                  value={
                    projectData.find((proj) => proj?._id === selectedProject) ||
                    null
                  }
                  onChange={(event, newValue) => handleProjectChange(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} placeholder="Select a Project" />
                  )}
                />
              </Grid>
              <Grid item md={1.5}>
                <Stack
                  component="div"
                  sx={{
                    border: "1px solid #D5DBDE",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "44px",
                    borderRadius: "6px",
                    cursor: "pointer",
                    flexDirection: "row-reverse",
                    gap: "10px",
                    padding: "0 12px",
                    position: "relative",
                  }}
                  onClick={handleFilterClick}
                >
                  <Typography>Filter</Typography>
                  <IoFilterSharp size={20} />
                  {(Object.values(selectedFilters).flat().length > 0 ||
                    isDateFiltered) && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: 7,
                        right: 63,
                        backgroundColor: "#008080",
                        color: "white",
                        borderRadius: "50%",
                        width: 15,
                        height: 15,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "11px",
                      }}
                    >
                      {Object.values(selectedFilters).flat().length +
                        (isDateFiltered ? 1 : 0)}
                    </Box>
                  )}
                </Stack>
                <Drawer
                  anchor="right"
                  open={openFilterDrawer}
                  onClose={handleCloseFilterDrawer}
                  sx={{
                    "& .MuiDrawer-paper": {
                      width: "350px",
                      padding: "20px",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 3,
                    }}
                  >
                    <Stack flexDirection={"row"} gap={1}>
                      <img src={filterIcon1} alt="Filter" />
                      <Typography variant="h6">Filters</Typography>
                    </Stack>
                    <Stack>
                      <IoClose
                        size={24}
                        onClick={handleCloseFilterDrawer}
                        style={{ cursor: "pointer" }}
                      />
                    </Stack>
                  </Box>

                  <Box sx={{ flexGrow: 1, overflowY: "auto" }}>
                    <Typography variant="subtitle1" sx={{ mb: 1 }}>
                      Date
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={["DatePicker"]}>
                        <DatePicker
                          views={["year", "month"]}
                          openTo="month"
                          value={dayjs(`${tempDate.year}-${tempDate.month}-01`)}
                          onChange={(newValue) => {
                            if (newValue) {
                              setTempDate({
                                month: newValue.month() + 1,
                                year: newValue.year(),
                              });
                            }
                          }}
                          slotProps={{
                            textField: {
                              fullWidth: true,
                              variant: "outlined",
                            },
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                    {filterOptions.map((filter, index) => (
                      <Box key={index} sx={{ my: 2 }}>
                        <Typography variant="subtitle1" sx={{ mb: 1 }}>
                          {filter.title}
                        </Typography>
                        <Autocomplete
                          multiple
                          options={filter.options}
                          value={tempFilters[filter.title] || []}
                          onChange={(event, newValue) => {
                            setTempFilters((prev) => ({
                              ...prev,
                              [filter.title]: newValue,
                            }));
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder={`Select ${filter.title}`}
                              variant="outlined"
                              fullWidth
                              sx={{
                                "&  .MuiOutlinedInput-root .MuiAutocomplete-input":
                                  {
                                    paddingTop: "0px",
                                  },
                              }}
                            />
                          )}
                          renderTags={() => null}
                          fullWidth
                        />
                        {tempFilters[filter.title]?.length > 0 && (
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 1,
                              mt: 1,
                              p: 1,
                              borderRadius: 1,
                            }}
                          >
                            {tempFilters[filter.title].map((value, idx) => (
                              <Chip
                                key={idx}
                                label={value}
                                onDelete={() =>
                                  handleRemoveFilter(filter.title, value)
                                }
                                deleteIcon={<IoClose size={14} />}
                                size="small"
                                sx={{
                                  padding: "5px",
                                  backgroundColor: "#C7EEEF",
                                  "& .MuiChip-deleteIcon": {
                                    color: "#616161",
                                    "&:hover": { color: "#212121" },
                                  },
                                }}
                              />
                            ))}
                          </Box>
                        )}
                      </Box>
                    ))}
                  </Box>

                  <Stack flexDirection={"row"} justifyContent={"space-between"}>
                    <Stack
                      onClick={handleClearAll}
                      sx={{
                        border: "1px solid #DDDDDD",
                        padding: "8px 10px",
                        borderRadius: "6px",
                        cursor: "pointer",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "black",
                        }}
                      >
                        Clear All
                      </Typography>
                    </Stack>
                    <Stack
                      onClick={handleApplyFilters}
                      sx={{
                        backgroundColor: "#008080",
                        padding: "8px 10px",
                        borderRadius: "6px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "white",
                          cursor: "pointer",
                        }}
                      >
                        Apply
                      </Typography>
                    </Stack>
                  </Stack>
                </Drawer>
              </Grid>
              <Grid item md={2}>
                <Stack
                  sx={{
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#008080",
                    borderRadius: "6px",
                    minHeight: "36px",
                    height: "44px",
                    cursor: "pointer",
                  }}
                  onClick={handleAddTaskClick}
                >
                  <GoPlus size={30} color="white" />
                  <Typography sx={{ color: "white" }}> Add Tas</Typography>
                </Stack>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Stack>
      <Divider />

      {viewMode === "board" ? (
        <TaskBoard
          // tasks={tasks}
          tasks={{
            ...tasks,
            Production: tasks.Production.filter(
              (item) => !(item.status === 3 && item.clientVerified === true)
            ),
          }}
          handleView={handleView}
          handleAddTaskClick={handleAddTaskClick}
          renderTaskCard={renderTaskCard}
        />
      ) : (
        <TaskList
          tasks={tasks}
          tableTotalCount={tableTotalCount}
          setSelectedTask={setSelectedTask}
          setOpenDrawer={setOpenDrawer}
          queryParam={queryParam}
          handleView={handleView}
          handleEdit={handleEdit}
          handleDelete={handleDelete}
        />
      )}

      <Dialog
        open={openDrawer}
        onClose={() => setOpenDrawer(false)}
        PaperProps={{
          style: {
            width: "100%",
            height: "fit-content",
          },
        }}
        fullWidth
        maxWidth="md"
      >
        <AddTaskClient
          selectedData={selectedTask}
          setOpenDrawer={setOpenDrawer}
          formType={
            selectedTask?.isView ? "view" : selectedTask?._id ? "edit" : "add"
          }
          GetData={GetClientTaskData}
        />
      </Dialog>
    </Grid>
  );
};

export default NewClientTaskManagement;
